import { render, staticRenderFns } from "./GuessHistory.vue?vue&type=template&id=07fa866a&scoped=true"
import script from "./GuessHistory.vue?vue&type=script&lang=js"
export * from "./GuessHistory.vue?vue&type=script&lang=js"
import style0 from "./GuessHistory.vue?vue&type=style&index=0&id=07fa866a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fa866a",
  null
  
)

export default component.exports